import React, {useEffect, useState, useRef} from 'react';
import dayjs from 'dayjs';

const Timer = ({duration = 120, timeUpCallback, className}) => {
  const [seconds, setSeconds] = useState(duration);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds - 1);
    }, 1000);
    return () => clearInterval(timerRef.current); // cleanup timer on component unmount
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      clearInterval(timerRef.current);
      timeUpCallback();
    }
  }, [seconds]);

  const formattedTime = dayjs()
    .startOf('day')
    .add(seconds, 'seconds')
    .format('m:ss');

  return <h2 className={className ?? "text-[15px] font-['CG-Medium'] text-[#000]"}>{formattedTime}</h2>;
};

export default Timer;